import React from 'react';

export function buildPilatesQuickActions({ pathname = '', actionsApi }) {
  const isSessions = pathname.startsWith('/app/pilates/sessions');
  if (!isSessions) return null;

  const s = actionsApi?.sessions;
  const p = actionsApi?.payments;

  const editOn = Boolean(s?.state?.editMode);
  const attOn = Boolean(s?.state?.attendanceMode);

  // ✅ ödeme handler: önce payments, yoksa sessions
  const takePaymentHandler = p?.openTakePayment || s?.openTakePayment || s?.openPayment || null;

  const safe =
    (fn, ...args) =>
    () => {
      try {
        if (!fn) {
          console.warn('[QuickActions] handler missing', { fn, args, s, p });
          return;
        }
        fn(...args);
      } catch (e) {
        console.error(e);
      }
    };

  return {
    title: 'Takvim Araçları',
    subtitle: 'Bugün • Yoklama • Düzenle',
    headerIcon: 'event_available',
    chips: [],
    footerText: null,
    bottomButtons: [],
    storageKey: 'solisup_quick_actions_open:pilates_sessions',

    actions: [
      {
        key: 'today',
        icon: 'today',
        title: 'Bugün',
        desc: 'Bugünkü seansları açar.',
        color: 'secondary',
        variant: 'text',
        ctaLabel: 'Aç',
        onClick: safe(s?.openToday),
      },

      // ✅ EKLENDİ: Ödeme Al
      {
        key: 'take_payment',
        icon: 'payments',
        title: 'Ödeme Al',
        desc: 'Paket / Seans / Diğer tahsilat.',
        color: 'warning',
        variant: 'text',
        ctaLabel: 'Aç',
        onClick: safe(takePaymentHandler),
      },

      {
        key: 'attendance_open_list',
        icon: 'fact_check',
        title: 'Yoklama',
        desc: 'Yoklama modunu açar ve listeyi getirir.',
        color: 'primary',
        variant: 'text',
        ctaLabel: 'Aç',
        onClick: () => {
          try {
            if (!s) return console.warn('[QuickActions] sessions api missing');
            s?.setAttendanceMode?.(true);
            s?.openAttendanceList?.();
          } catch (e) {
            console.error(e);
          }
        },
      },

      {
        key: 'edit_toggle',
        icon: 'edit',
        title: editOn ? 'Düzenleme Açık' : 'Düzenleme',
        desc: editOn ? 'Düzenleme modu açık.' : 'Düzenleme modunu açar.',
        color: 'success',
        variant: 'text',
        ctaLabel: editOn ? 'Kapat' : 'Aç',
        onClick: safe(s?.setEditMode, !editOn),
      },
    ],
  };
}
